export const Paging = {
    ENTITY_PAGE_SIZE: 20,
    ENTITY_MAX_BATCH_SIZE: 60,
}
